// Public hospitals and small health services across the Warren-Blackwood
// electorate. Coordinates are approximate town centres (good enough for a
// "nearest hospital" calculation at locality-page granularity).
// Source: WA Country Health Service (WACHS) facility directory.

import type { ShireId } from '../../components/shared/electorate-shires';

export interface Hospital {
  name: string;
  town: string;
  shireId: ShireId;
  /** Short level / role description (e.g. "Small hospital with ED"). */
  level: string;
  /** WACHS website for the facility. */
  url: string;
  /** Optional facility phone number. */
  phone?: string;
  lat: number;
  lon: number;
}

export const HOSPITALS: Hospital[] = [
  {
    name: 'Margaret River Hospital',
    town: 'Margaret River',
    shireId: 'augusta-margaret-river',
    level: 'Integrated district health service with 24/7 emergency department',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    lat: -33.9542,
    lon: 115.0760,
  },
  {
    name: 'Augusta Hospital',
    town: 'Augusta',
    shireId: 'augusta-margaret-river',
    level: 'Small rural hospital and residential aged-care',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    lat: -34.3144,
    lon: 115.1591,
  },
  {
    name: 'Warren Health Service (Manjimup)',
    town: 'Manjimup',
    shireId: 'manjimup',
    level: 'District hospital with 24/7 emergency department — regional referral centre',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    phone: '(08) 9772 5100',
    lat: -34.2412,
    lon: 116.1457,
  },
  {
    name: 'Pemberton Hospital',
    town: 'Pemberton',
    shireId: 'manjimup',
    level: 'Small rural hospital with 24/7 emergency and aged-care beds',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    lat: -34.4456,
    lon: 116.0383,
  },
  {
    name: 'Northcliffe Health Centre',
    town: 'Northcliffe',
    shireId: 'manjimup',
    level: 'Northcliffe Nursing Post — emergency care Mon–Fri 9am–4:30pm (with Emergency Telehealth). Phone (08) 9776 7080. Outside these hours call 000.',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    phone: '(08) 9776 7080',
    lat: -34.6356,
    lon: 116.1228,
  },
  {
    name: 'Bridgetown Hospital',
    town: 'Bridgetown',
    shireId: 'bridgetown-greenbushes',
    level: 'Small hospital with emergency department and aged-care beds',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    lat: -33.9590,
    lon: 116.1394,
  },
  {
    name: 'Boyup Brook Health Service',
    town: 'Boyup Brook',
    shireId: 'boyup-brook',
    level: '12-bed B-class hospital with aged-care and emergency cover',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    lat: -33.8313,
    lon: 116.3923,
  },
  {
    name: 'Nannup Hospital',
    town: 'Nannup',
    shireId: 'nannup',
    level: 'Small rural hospital and aged-care service',
    url: 'https://wacountry.health.wa.gov.au/Our-services/South-West/South-West-health-services/hospitals-and-health-services',
    lat: -33.9819,
    lon: 115.7672,
  },
  {
    name: 'Denmark Hospital',
    town: 'Denmark',
    shireId: 'denmark',
    level: 'Small hospital with 24/7 emergency department',
    url: 'https://wacountry.health.wa.gov.au/Our-services/Great-Southern/Great-Southern-health-services/hospitals-and-health-services',
    lat: -34.9605,
    lon: 117.3528,
  },
  {
    name: 'Walpole Health Service',
    town: 'Walpole',
    shireId: 'manjimup',
    level: 'Nursing post and community health (no emergency department)',
    url: 'https://wacountry.health.wa.gov.au/Our-services/Great-Southern/Great-Southern-health-services/hospitals-and-health-services',
    lat: -34.9776,
    lon: 116.7321,
  },
];
